import axios from "axios"
import { CREATIVES_URL } from "src/constants"

export const getAdsWithCreatives = async (userId, folderId) => {
  const url = folderId
    ? `${CREATIVES_URL}/${userId}?folderId=${folderId}`
    : `${CREATIVES_URL}/${userId}`
  return await axios.get(url)
}
